export default {
  state: {
    userInfo: {}, // 服务派单 用户信息
    plcUserInfo: null, // 渠道商 用户信息
    total: 0 // 渠道商 购物车数量
  },
  mutations: {
    setEcologyUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    setPlcUserInfo (state, userInfo) {
      state.plcUserInfo = userInfo
    },
    setTotal (state, total) {
      state.total = total
    }
  },
  actions: {
  }
}
